import { Link } from "react-router-dom";
import { newsItems } from "@/mocks/news";
import SectionHeading from "./SectionHeading";
import { formatCompact } from "@/utils/format";

export default function NewsHighlight() {
  const latest = newsItems.slice(0, 3);
  const [featured, ...rest] = latest;

  return (
    <section className="px-4 md:px-6 py-14 md:py-20 bg-background-100">
      <SectionHeading
        eyebrow="独家精选"
        title="投资资讯精选"
        description="精选最新权威市场分析文章，浓缩核心观点，帮助您快速把握黄金市场的关键变化。"
        linkTo="/category/investment-news"
        linkLabel="更多资讯"
      />

      <div className="grid grid-cols-1 lg:grid-cols-12 gap-5">
        {featured && (
          <Link
            to={`/detail/news/${featured.id}`}
            className="lg:col-span-7 group rounded-lg overflow-hidden border border-background-200 bg-background-50"
          >
            <div className="w-full h-56 md:h-72 overflow-hidden bg-background-200">
              <img
                src={featured.cover}
                alt={featured.title}
                title={`${featured.title} - 黄金投资资讯`}
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="p-6">
              <div className="flex flex-wrap items-center gap-3 text-xs text-foreground-500 mb-3">
                <span className="px-2.5 py-1 rounded-full bg-accent-100 text-accent-900 font-label">
                  {featured.category}
                </span>
                <span className="flex items-center gap-1"><i className="ri-user-line" />{featured.author}</span>
                <span className="flex items-center gap-1"><i className="ri-calendar-line" />{featured.date}</span>
                <span className="flex items-center gap-1"><i className="ri-eye-line" />{formatCompact(featured.views)}</span>
              </div>
              <h3 className="font-heading font-bold text-xl md:text-2xl text-foreground-950 leading-snug mb-3 group-hover:text-primary-600 transition-colors">
                {featured.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed line-clamp-3">{featured.summary}</p>
            </div>
          </Link>
        )}

        <div className="lg:col-span-5 flex flex-col gap-5">
          {rest.map((item) => (
            <Link
              key={item.id}
              to={`/detail/news/${item.id}`}
              className="group flex-1 flex gap-4 rounded-lg border border-background-200 bg-background-50 p-5"
            >
              <div className="flex-1 min-w-0">
                <div className="flex flex-wrap items-center gap-2 text-xs text-foreground-500 mb-2">
                  <span className="px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-900 font-label">
                    {item.category}
                  </span>
                  <span>{item.date}</span>
                </div>
                <h3 className="font-heading font-bold text-base text-foreground-950 leading-snug mb-2 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">{item.summary}</p>
              </div>
              <div className="w-24 h-24 md:w-28 md:h-28 rounded-md overflow-hidden shrink-0 bg-background-200">
                <img
                  src={item.cover}
                  alt={item.title}
                  title={`${item.title} - 黄金投资资讯`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}